import React from "react";

const PlanTab = () => {
    return (
        <div className="tab-content-box">
            <div className="row">
                <div className="col-lg-3">
                    <h2 className="section-title">Plan Details</h2>
                    <div className="info-card text-center">
                        <h5 className="info_card_heading">Current plan</h5>
                        <img src="assets/imgs/plan.png" alt="" className="gift-img" />
                        <h6 className="plan_heading">
                            <span className="days_count">30</span> days left to renew
                        </h6>
                    </div>
                </div>
                <div className="col-lg-9">
                    <h2 className="section-title">Invoice</h2>
                    <div className="invoice-card">
                        <div className="table-responsive">
                            <table className="table invoice-table align-middle">
                                <thead>
                                    <tr>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Days Left</th>
                                        <th>Cost</th>
                                        <th>Invoice</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>24 May 2024</td>
                                        <td>24 June 2024</td>
                                        <td>30 Days</td>
                                        <td>₹500</td>
                                        <td><button className="download-btn">Download</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="cancel-plan-box">
                        Plan cancellation: <a href="#">Click here</a> to cancel the current plan.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlanTab;